import Box from "@mui/material/Box";
import useUploadImage from "./useUploadImage";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import styles from "./UploadImage.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCanXmark } from "@fortawesome/pro-solid-svg-icons";

type UploadButtonProps = {
    fieldName: string;
    selectedFiles: any[];
    setSelectedFiles: any;
    error: any;
    helperText: any;
    imagesData?: any;
    setDeletedFiles?: any;
    isFetching?: boolean;
}

const UploadButton = (props: UploadButtonProps) => {
    const { fieldName, setSelectedFiles, error, helperText, imagesData, setDeletedFiles, isFetching } = props
    const { states, functions } = useUploadImage(fieldName, setSelectedFiles, imagesData, setDeletedFiles, isFetching);

    return (
        <Box className={styles.upload_wrapper}>
            <input
                type="file"
                ref={states.fileInputRef}
                accept="image/png,image/jpeg,image/jpg"
                multiple
                hidden
                onChange={functions.handleFilesChange}
            />

            {states.images.length ? <Box className={styles.preview_row}>
                {states.images?.length > 0 && states.images.map((img: any, index: any) => (
                    <Box className={styles.preview_card} key={index}>
                        <img src={img?.url} alt="preview" />
                        <Typography
                            className={styles.remove_btn}
                            onClick={() => functions.removeImage(img?.doc_id)}
                        >
                            <FontAwesomeIcon icon={faTrashCanXmark} style={{ color: "#f94054", width: "10px", height: "10px" }} />
                        </Typography>
                    </Box>
                ))}

                {states.images.length === 1 ?
                    <>
                        <Box className={styles.preview_card__empty} />
                        <Box className={styles.preview_card__empty} />
                    </> : states.images.length === 2 ?
                        <Box className={styles.preview_card__empty} /> :
                        <></>
                }
            </Box> : <></>}

            <Button className={styles.upload_btn} onClick={functions.handleUploadClick}>
                {functions.translate("uploadButtonText")}
            </Button>

            <Box className={styles.description}>
                <Typography>
                    {functions.translate("uploadLimitText")}
                </Typography>
                <Typography>
                    {functions.translate("uploadImageType")}
                </Typography>
            </Box>
            {error && (
                <Typography className="error_message" style={{ marginTop: 3 }}>
                    {helperText}
                </Typography>
            )}
        </Box>)
}
export default UploadButton